import common from '../index.module.scss';
import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntrySingleLine } from '../settings-entry';
import { BackgroundsIcon } from '..';
import { h } from 'vue';
import { Flex } from '@phi/components/layout';
import { Lights } from '@frontend/Colours';

const lightingregular_png = 'img/lightingregular.png';
const lightingdisco_png = 'img/lightingdisco.png';
const lightingurban_png = 'img/lightingurban.png';

export function LightingPicker() {
    return SettingsEntrySingleLine(
        'Scene lighting',

        undefined,

        img(BackgroundsIcon, 'Scene lighting'),

        h(Flex, { direction: 'row', gap: 'tight' }, () => [
            h('button', {
                title: 'Regular',
                type: 'button',
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.lights === Lights.regular
                },
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Regular lighting.',
                onClick: () => app.settings.lights = Lights.regular,
            }, img(lightingregular_png)),

            h('button', {
                title: 'Disco',
                type: 'button',
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.lights === Lights.disco
                },
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Disco lighting.',
                onClick: () => app.settings.lights = Lights.disco,
            }, img(lightingdisco_png)),

            h('button', {
                title: 'Urban',
                type: 'button',
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.lights === Lights.urban
                },
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Urban lighting.',
                onClick: () => app.settings.lights = Lights.urban,
            }, img(lightingurban_png)),
        ])
    );
}
